import i18n from 'modules/core/lib/i18n'

const getFilterOperatorsLabel = (type: string) => {
  switch (type) {
    case 'between':
      return i18n.t('custom_reports.filter_operators.between')
    case 'contains':
      return i18n.t('custom_reports.filter_operators.contains')
    case 'eq':
      return i18n.t('custom_reports.filter_operators.eq')
    case 'gt':
      return i18n.t('custom_reports.filter_operators.gt')
    case 'gteq':
      return i18n.t('custom_reports.filter_operators.gteq')
    case 'lt':
      return i18n.t('custom_reports.filter_operators.lt')
    case 'lteq':
      return i18n.t('custom_reports.filter_operators.lteq')
    case 'matches':
      return i18n.t('custom_reports.filter_operators.matches')
    case 'not_eq':
      return i18n.t('custom_reports.filter_operators.not_eq')
    case 'not_null':
      return i18n.t('custom_reports.filter_operators.not_null')
    case 'null':
      return i18n.t('custom_reports.filter_operators.null')
    case 'starts_with':
      return i18n.t('custom_reports.filter_operators.starts_with')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

const getDateFilterOperatorsLabel = (type: string) => {
  switch (type) {
    case 'between':
      return i18n.t('custom_reports.date_filter_operators.between')
    case 'current_day':
      return i18n.t('custom_reports.date_filter_operators.current_day')
    case 'current_month':
      return i18n.t('custom_reports.date_filter_operators.current_month')
    case 'current_quarter':
      return i18n.t('custom_reports.date_filter_operators.current_quarter')
    case 'current_week':
      return i18n.t('custom_reports.date_filter_operators.current_week')
    case 'current_year':
      return i18n.t('custom_reports.date_filter_operators.current_year')
    case 'gt':
      return i18n.t('custom_reports.date_filter_operators.gt')
    case 'gteq':
      return i18n.t('custom_reports.date_filter_operators.gteq')
    case 'last_days':
      return i18n.t('custom_reports.date_filter_operators.last_days')
    case 'last_months':
      return i18n.t('custom_reports.date_filter_operators.last_months')
    case 'last_quarters':
      return i18n.t('custom_reports.date_filter_operators.last_quarters')
    case 'last_weeks':
      return i18n.t('custom_reports.date_filter_operators.last_weeks')
    case 'last_years':
      return i18n.t('custom_reports.date_filter_operators.last_years')
    case 'lt':
      return i18n.t('custom_reports.date_filter_operators.lt')
    case 'lteq':
      return i18n.t('custom_reports.date_filter_operators.lteq')
    case 'not_null':
      return i18n.t('custom_reports.date_filter_operators.not_null')
    case 'null':
      return i18n.t('custom_reports.date_filter_operators.null')
    case 'this_month_or_after':
      return i18n.t('custom_reports.date_filter_operators.this_month_or_after')
    case 'this_month_or_before':
      return i18n.t('custom_reports.date_filter_operators.this_month_or_before')
    case 'this_week_or_after':
      return i18n.t('custom_reports.date_filter_operators.this_week_or_after')
    case 'this_week_or_before':
      return i18n.t('custom_reports.date_filter_operators.this_week_or_before')
    case 'today_or_after':
      return i18n.t('custom_reports.date_filter_operators.today_or_after')
    case 'today_or_before':
      return i18n.t('custom_reports.date_filter_operators.today_or_before')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

export const getOperatorLabel = (type: string, operator: string) => {
  if (type === 'date') {
    return getDateFilterOperatorsLabel(operator ?? '')
  }

  return getFilterOperatorsLabel(operator ?? '')
}
